export const WELCOME_LABEL = 'For organizations and power users'
export const WELCOME_TITLE = 'Own your assets onchain securely'
export const WELCOME_FEATURES = ['Non-custodial', 'Built on Safe protocol']
